import React from 'react';
import PropTypes from "prop-types";

class Label extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {required, value, children, ...restProps} = this.props;
        return (
            <label {...restProps}>
                {children ? children : value}
                {required ? <span style={{color: "red"}}>*</span> : null}
            </label>
        );
    }
}

Label.propTypes = {
    required: PropTypes.any,
    value: PropTypes.any
};
export default Label;